import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfigService } from './appConfigService';
import {PeopleProfileInfo} from '../model/PeopleProfileInfo'
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PeopleProfileService {
  IntegrationAPIEndPoint: string;
  emailId: string;

  constructor(private http: HttpClient, private sanitizer: DomSanitizer, private environment: AppConfigService) {
     this.IntegrationAPIEndPoint = environment.config.DATA.API_END_POINT.INTEGRATION_API_URL;
   }
  
    GetPeopleProfileInfoByEmailID(emailId : string): Observable<PeopleProfileInfo> {
       return this.http.get<PeopleProfileInfo>(this.IntegrationAPIEndPoint + '/PeopleProfile/GetPeopleProfileInfoByEmailID?emailId=' + emailId);
     }
  
}
